import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { UserActions } from '../store/actions/user.actions';
import { MdDialog, MdSnackBar } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ApiService {

  baseUrl: string;
  options: any;
  userToken: any;
  header: any;

  /**
   * Load dependencies and initialize variables, headers and options
   * @param {HttpClient} http
   * @param {Router} router
   * @param {UserActions} userActions
   * @param {MdDialog} mdDialog
   * @param {MdSnackBar} snackBar
   */
  constructor(private http: HttpClient,
    private router: Router,
    private mdDialog: MdDialog,
    private userActions: UserActions,
    private snackBar: MdSnackBar
    ) {
        this.baseUrl = environment.apiUrl;
  }

  /**
   * Do a get request and process the result
   * @param {string} webservice
   * @returns {Observable<any>}
   */
  get(webservice: string): Observable<any> {

    //Please do not displace this code from here, it may not work
    if (!localStorage.getItem('BearerToken')) {
      this.header = new HttpHeaders().set('Content-Type', 'application/json');
    }
    else
    {
      this.userToken = JSON.parse(localStorage.getItem('BearerToken'));
      this.header = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${this.userToken}`);
    }

    this.options = {headers: this.header,withCredentials: true,observe: 'response'};

    return this.http.get(this.baseUrl + webservice, this.options).map((res) => {
      return this.handleResponse(res);
    }).catch(e => {
      return this.handleError(e);
    });
  }

  /**
   * Do a post request and process the result
   * @param {string} webservice
   * @param data
   * @returns {Observable<any>}
   */
  post(webservice: string, data: any): Observable<any> {

    //Please do not displace this code from here, it may not work
    if (!localStorage.getItem('BearerToken')) {
      this.header = new HttpHeaders().set('Content-Type', 'application/json');
    }
    else
    {
      this.userToken = JSON.parse(localStorage.getItem('BearerToken'));
      this.header = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${this.userToken}`);
    }

    this.options = {headers: this.header,withCredentials: true,observe: 'response'};

    let cleanData = data;
    if (typeof data === 'object' && data['password'] === undefined) {
      cleanData = this.removeCircularReferences(data);
    }

    return this.http.post(this.baseUrl + webservice, cleanData, this.options).map((res) => {
      return this.handleResponse(res);
    }).catch(e => {
      return this.handleError(e);
    });
  }

  /**
   * Do a delete request and process the result
   * @param {string} webservice
   * @returns {Observable<any>}
   */
  delete(webservice: string): Observable<any> {

    this.header = new HttpHeaders().set('Content-Type', 'application/json');
    this.options = {headers: this.header,withCredentials: true,observe: 'response'};

    return this.http.delete(this.baseUrl + webservice, this.options).map((res) => {
      return this.handleResponse(res);
    }).catch(e => {
      return this.handleError(e);
    });
  }

  /**
   * Handle the response when it's a success
   * @param res
   * @returns {ErrorObservable}
   */
  handleResponse(res) {
    if (res.status < 200 || res.status >= 300) {
      this.snackBar.open('Server error', null, {
        duration: 3000,
      });
      return Observable.throw('Server error');
    } else {
      return res.body;
    }
  }

  /**
   * Handle the response when it's an error
   * @param res
   * @returns {ErrorObservable}
   */
  handleError(e) {
    if (e.status === 401) {
      // noinspection JSIgnoredPromiseFromCall
      this.mdDialog.closeAll();
      this.userActions.logoutUser();
      this.router.navigate(['/login']);
      return Observable.throw(e.error.message);
    } else {
      this.snackBar.open('Server error', null, {
        duration: 3000,
      });
      return Observable.throw('Server error');
    }
  }

  removeCircularReferences(obj) {
    const KEYS_TO_CLEAR = ["__zone_symbol__loadfalse", "original", "_locale"]

    const removed = [];
    const traverse = (value, path) => {
      if (typeof value === 'object' && value !== null) {
        for (const key in value) {
          if (value.hasOwnProperty(key)) {
            if (KEYS_TO_CLEAR.includes(key) || key.startsWith("__zone_symbol__")) {
              removed.push({key, path})
              delete value[key]
            } else {
              value[key] = traverse(value[key], `${path}.${key}`);
            }
          }
        }
      }
      return value;
    };
    const cleanedUpValue = traverse(obj, "");

    return cleanedUpValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts